import { lureoButtonClass } from '@/common/lureoButtonClass';
import { cn } from '@/utils/utils';
import { DisplayTitle } from '@/components/ui/text';
import { PageFrame } from '@/components/ui/page-frame';

const NotFound = () => {
  return (
    <PageFrame layout="centred">
      <div className="text-center max-w-md w-full">
        <DisplayTitle tone="default" className="mb-4">404</DisplayTitle>
        <p className="text-lureo-18 md:text-lureo-20 text-lureo-ink-subtle mb-6 leading-7 md:leading-7">Oops! Page not found</p>
        <a href="/" className={PRIMARY_LINK}>
          Return to Home
        </a>
      </div>
    </PageFrame>
  );
};

// LureoButton's secondary (primary action) look on a link that must stay a link
const PRIMARY_LINK = cn(lureoButtonClass('secondary'), 'h-12 justify-center rounded-lureo-radius-button-pill px-6');

export default NotFound;
